import {
    HttpResponse,
    TenantModel,
    QueryModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class AdminTenantsDataService implements CrudService<TenantModel, TenantModel> {
    getAll(query: CrudDataQuery<TenantModel>): Promise<CrudEnumerableResponse<TenantModel>> {
        return ApiService.api.adminGetTenantBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }
    
    getBasicAll(query: CrudDataQuery<TenantModel>): Promise<CrudEnumerableResponse<TenantModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<TenantModel>> {
        return ApiService.api.adminGetTenantById(id, params);
    }

    create(item: TenantModel, params?: RequestParams): Promise<CrudResponse<TenantModel>> {
        throw new Error('NotImplemented');
    }

    update(item: TenantModel, params?: RequestParams): Promise<TenantModel> {
        return ApiService.api.adminUpdateTenant(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<TenantModel> {
        throw new Error('NotImplemented');
    }

    delete(query: CrudDataQuery<TenantModel>): Promise<CrudEnumerableResponse<TenantModel>> {
        throw new Error('NotImplemented');
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error('NotImplemented');
    }
    
    download(query: CrudDataQuery<TenantModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: TenantModel, params?: RequestParams): Promise<CrudResponse<TenantModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error('NotImplemented');
    }

}
